import React, { useContext, useEffect, useReducer, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import { Toolbar, Grid, Snackbar } from '@material-ui/core/';
import { BookmarkBorderOutlined, PictureAsPdfOutlined } from '@material-ui/icons';
import { Alert } from '@material-ui/lab';
import logo from '../assets/img/logo.png'
import FormUser from './FormUser';
import Modal from './Modal';
import { liquidationReducer } from '../reducers/liquidationReducer';
import FormLiquidation from './FormLiquidation';
import '../css/main.css';
import HeaderModules from './HeaderModules';
import { fb } from '../utils/Firebase';
import { LoadingContext } from '../context/Loading';

const initialState = [];

const Main = () => {

    const classes = useStyles();
    const [visibleModal, setVisibleModal] = useState(false);
    const [snackbar, setSnackbar] = useState({ visible: false, message: '' });
    const [data, setData] = useState(null);
    const [services, setServices] = useState({
        form: {
            name: 'formulario de renovación',
            value: 7900
        }
    })
    const [affiliation, setAffiliation] = useState('');
    const [video, setVideo] = useState({});

    const { setIsReady } = useContext(LoadingContext);
    
    const [state, dispatch] = useReducer(liquidationReducer, initialState);

    useEffect(() => {
        let subscribed = true;
    
        if(subscribed) {
            (async () => {
                const response = await fb.firestore().collection('configuraciones').doc('principal').get();
                setVideo(response.data().video);
                setIsReady(true);
            })();
        }
       
        return () => subscribed = false;
    }, []);

    const numberFormat = number => {
        return new Intl.NumberFormat("es-CO", { style: 'currency', currency: 'COP', minimumFractionDigits: 0 }).format(number);
    }

    return (
        <> 
            <AppBar position="fixed" style={{ background: '#00365F' }}>
                <Toolbar>
                    <img src={logo} alt='' width={120}  />
                </Toolbar>
            </AppBar>

            <Grid container alignItems='center' justify='center' style={{ marginTop: 60 }}>
                <Grid item xs={12}>
                    <HeaderModules 
                        icon={<BookmarkBorderOutlined htmlColor='rgba(0,0,0, .7)' />} 
                        title={`Liquidador de renovación año ${new Date().getFullYear()}`} 
                        margin={10} 
                    />
                </Grid>

                <Grid item xs={12}>
                    <div className={classes.containerForm}>
                        {
                            !data ? <FormUser setData={setData} setSnackbar={setSnackbar} /> : (
                                <FormLiquidation 
                                    data={data} 
                                    setData={setData}
                                    numberFormat={numberFormat} 
                                    setIsReady={setIsReady}
                                    dispatch={dispatch}
                                    setVisibleModal={setVisibleModal}
                                    setServices={setServices}
                                    setAffiliation={setAffiliation}
                                />
                            )
                        }
                    </div>
                </Grid>

                {
                    video?.visible && (
                        <Grid item xs={12}>
                            <div className={` ${classes.responsiveContentVideo}`} id='container'>
                                <iframe className={classes.iframe} id='iframe' src={video?.url} title='video' frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
                            </div>
                            
                            <div style={{ padding: '0 10px 10px 10px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                <PictureAsPdfOutlined htmlColor='#e63946' fontSize='large' />
                                <a href="https://www.camaracartago.org/wp-content/uploads/2023/01/Paso-A-paso-renovacion.pdf" target="_blank" rel="noopener noreferrer" style={{ fontSize: 14, textDecoration: 'none', marginLeft: 2, fontWeight: 'bolder', color: 'rgba(0,0,0,.7)' }}>Ver paso a paso</a>
                            </div>

                        </Grid>
                    )
                }
               
                <Grid item xs={12} >
                    <Alert variant="filled" severity="success" style={{ textAlign: 'justify', fontSize: 13, background: '#127296', fontWeight: 'normal', marginLeft: 10, marginRight: 10, marginBottom: 10, borderRadius: 6}}>
                        Al renovar tu matrícula mercantil antes del 31 de marzo, podrás tener acceso a los siguientes beneficios establecidos en la circular 003 de 2019 de la SIC:
                        <ol>
                            <li>Acceso en la información que reposa en el Registro Único Empresarial y Social - RUES de todos los comerciantes (personas naturales y jurídicas) inscritos en el registro mercantil que tengan su matrícula y la de sus establecimientos de comercio renovada.</li>
                            <li>Acceso a los programas, eventos, capacitaciones, cursos virtuales o presenciales que tiene la Cámara de Comercio de Cartago para ti durante el año {new Date().getFullYear()}.</li>
                        </ol>
                        Ingresa a <a href="https://www.camaracartago.org/2022/02/25/beneficios-de-la-formalizacion/" target="_blank" rel="noopener noreferrer" style={{ color: '#fff', fontWeight: 'bold' }}>https://www.camaracartago.org/2022/02/25/beneficios-de-la-formalizacion</a> y entérate de todos los beneficios que tienes al renovar a tiempo.
                    </Alert>
                
                    <Alert variant="filled" severity="success" style={{ background: '#127296', textAlign: 'justify', fontSize: 13, fontWeight: 'normal', marginLeft: 10, marginRight: 10, marginBottom: 10, borderRadius: 6}}>
                        Si eres beneficiario de la Ley 1780 de 2016, podrás obtener exención en el pago de la renovación de la matrícula de persona durante el primer año, simpre y cuando cumplas con los siguientes requisitos:
                        <ol>
                            <li>Relación de trabajadores vinculados directamente con la empresa, si los tuviere, indicando el nombre e identificación de los mismos.</li>
                            <li>Que la empresa ha realizado los aportes al Sistema de Seguridad Social Integral y demás contribuciones de nómina, en caso de estar obligada a ello, y ha cumplido con sus obligaciones oportunamente en materia tributaria.</li>
                            <li>Presentar copia de los estados financieros debidamente firmados por el contador o revisor fiscal, según el caso, con corte al 31 de diciembre del año inmediatamente anterior.</li>
                        </ol>
                        Para obtener el beneficio antes expuesto, se deberá cumplir con la totalidad de requisitos. El no cumplimiento lo excluirá de la exención en el pago de la renovación de matrícula de persona.
                    </Alert>
                
                    <Alert variant="filled" severity="info" style={{ background: '#D76F21', textAlign: 'justify', fontSize: 13, fontWeight: 'normal', marginLeft: 10, marginRight: 10, marginBottom: 10, borderRadius: 6}}>
                        El costo de la renovación puede variar dependiendo de los activos que tengas registrado en la Cámara de Comercio.
                    </Alert>
                
                    <Alert variant="filled" severity="info" style={{ background: '#D76F21', textAlign: 'justify', fontSize: 13, fontWeight: 'normal', marginLeft: 10, marginRight: 10, marginBottom: 10, borderRadius: 6}}>
                        Recuerda que para disminuir los activos en más de $1.000.000 debes anexar el estado de situación financiera correspondiente.
                    </Alert>
                </Grid>

                <Modal
                    state={state}
                    dispatch={dispatch}
                    visible={visibleModal}
                    setVisible={setVisibleModal}
                    numberFormat={numberFormat}
                    services={services}
                    affiliation={affiliation}
                    setAffiliation={setAffiliation}
                />
            </Grid>

            <Snackbar open={snackbar.visible} autoHideDuration={6000} onClose={() => setSnackbar(e => ({...e, visible: false}))} style={{ width: '100%' }}>
                <Alert severity="error" variant='filled' style={{ width: '100%', marginLeft: 10, marginRight: 10 }}>
                    {snackbar.message}
                </Alert>
            </Snackbar>
        </>
    );
}

const useStyles = makeStyles((theme) => ({
    menuButton: {
        marginRight: theme.spacing(2),
    },
    title: {
        flexGrow: 1,
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff',
    },
    responsiveContentVideo: {
        background: '#000',
        height: 650,
        marginLeft: 10,
        marginRight: 10,
        marginBottom: 10,
        borderRadius: 6,
        display: 'flex',
        justifyContent: 'center'
    },
    iframe: {
        width: '70%',
        height: '100%'
    },
    containerForm: {
        background: '#00365F',
        marginRight: 10,
        marginLeft: 10,
        marginBottom: 10,
        borderRadius: 6,
        display: 'flex',  
        justifyContent: 'center',
        alignItems: 'center',
        height: 500
    }
}));

export default Main;